export default __webpack_public_path__ + "static/short-statement-dont-5dd24cac4497c57aa8b189e295a63b13aadd7f921f0b676f45f926a34bbc2132.png";